import AppSidebarV2 from './AppSidebarV2';

export default AppSidebarV2;
